import { z } from 'zod';

export const providedJobPostsFormSchema = z
  .object({
    title: z.string().min(1),
    status: z.string().min(1),
    /** 既存企業を選択した場合に設定される企業ID */
    companyId: z.string().optional(),
    /** フリーテキスト入力による新規企業名 */
    companyName: z.string().optional(),
    jobPositionName: z.string().min(1),
    workingLocation: z.string().optional(),
    /** 雇用形態。空文字は「自動判定」（サーバ側で nil 正規化し分類器に委譲） */
    employmentType: z
      .enum(['', 'full_time', 'contract', 'outsourcing', 'dispatch', 'part_time', 'other'])
      .optional(),
    minSalary: z.string().optional(),
    maxSalary: z.string().optional(),
    jobContentJson: z.array(
      z.object({
        key: z.string().min(1),
        content: z.string().optional(),
      })
    ),
  })
  .refine((data) => Boolean(data.companyId) || Boolean(data.companyName?.trim()), {
    message: '企業名を入力するか、候補から企業を選択してください',
    path: ['companyName'],
  });

export type ProvidedJobPostsFormSchema = z.infer<typeof providedJobPostsFormSchema>;
